export default "__VITE_ASSET__DbyIJpoU__"